<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">

  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button (click)="createBoxInterface()" *ngIf="!embeddedLayout" color="primary" mat-button>
        New box interface
      </button>
      <button (click)="addBoxInterfaces(box)" *ngIf="embeddedLayout && box && !iAmCustomer" color="primary" mat-button>
        Add interfaces to this box
      </button>
    </div>


    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortInterfaces($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      matSort multiTemplateDataRows>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
        <td *matCellDef="let element" mat-cell> {{element.name}} </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Description</th>
        <td *matCellDef="let element" mat-cell> {{element.description}} </td>
      </ng-container>

      <!-- Box Column -->
      <!--      <ng-container matColumnDef="box">-->
      <!--        <th *matHeaderCellDef mat-header-cell mat-sort-header>Assigned Box</th>-->
      <!--        <td *matCellDef="let element" mat-cell> {{element.box?.identifier}} </td>-->
      <!--      </ng-container>-->


      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <ng-container *ngIf="!embeddedLayout">
              <button (click)="editBoxInterface(element)" *awIsInAnyRole="[roles.admin, roles.logistic]"
                [disabled]="disabled" mat-icon-button matTooltip="Edit interface">
                <mat-icon>edit</mat-icon>
              </button>
              <ng-container *ngIf="element.boxes.length === 0">
                <button (click)="deleteBoxInterface(element)" *awIsInAnyRole="[roles.admin]" [disabled]="disabled"
                  mat-icon-button matTooltip="Delete interface">
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-container>

            </ng-container>
            <ng-container *ngIf="embeddedLayout && box">
              <button (click)="removeBoxInterface(element)" *awIsInAnyRole="[roles.admin, roles.logistic]"
                [disabled]="disabled" mat-icon-button matTooltip="Remove interface from this box">
                <mat-icon>remove_circle</mat-icon>
              </button>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <!--      <tr *matRowDef="let row; columns: ['expandedDetail']"-->
      <!--          [fxShow]="expandedContractEventsHistory?.id === row.id" mat-row></tr>-->


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No interfaces found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorBoxInterfaces [fxShow]="dataSource && dataSource.data.length > 10"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>